import { useTranslation } from 'react-i18next'

interface Props {
  response1?: string | null
  response2?: string | null
}

function isAudioUrl(s: string | null | undefined): boolean {
  return typeof s === 'string' && s.startsWith('https://')
}

export function AudioResponseList({ response1, response2 }: Props) {
  const { t } = useTranslation('coaching')
  const slots = [
    { n: 1, url: response1 },
    { n: 2, url: response2 },
  ].filter((s) => s.url)

  if (slots.length === 0) {
    return <p className="text-xs text-gray-500">{t('guide.noAudio')}</p>
  }
  return (
    <div className="space-y-2">
      {slots.map(({ n, url }) => (
        <div key={n}>
          <p className="text-xs text-gray-600 mb-1">{t('guide.responseLabel', { n })}</p>
          {isAudioUrl(url) ? (
            <audio src={url!} controls className="w-full h-8" />
          ) : (
            <p className="whitespace-pre-wrap break-words rounded-lg border border-gray-200 bg-white px-4 py-3 text-2xl font-semibold leading-9 text-gray-950">
              {url}
            </p>
          )}
        </div>
      ))}
    </div>
  )
}
